import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { PopupCheckDataAvailability } from '../../../../common/order/popup/popupCheckDataAvailability'

export const RequestContact = () => {
  const [isOpenPopupCheckData, setIsOpenPopupCheckData] = useState(false)

  const onOpenPopupCheckData = () => {
    setIsOpenPopupCheckData(true)
  }

  const onClosePopupCheckData = () => {
    setIsOpenPopupCheckData(false)
  }

  return (
    <Element className="dFlex alignItemsCenter">
      <Element elementName="span" style={{ color: '#9C9C9C' }}>
        <Translate value="financialStatement.REQUEST_CONTACT_NOTE1" />
        <Element
          elementName="span"
          className="cursorPointer wFitContent"
          style={{ color: '#2C73E8' }}
          onClick={onOpenPopupCheckData}
        >
          <Translate value="financialStatement.REQUEST_CONTACT_NOTE2" />
        </Element>
      </Element>

      <PopupCheckDataAvailability
        isOpen={isOpenPopupCheckData}
        onClose={onClosePopupCheckData}
        idReport={8}
      />
    </Element>
  )
}
